// The discount code a shopper carries through a visit: one a shared link brought (?discount=WELCOME15), as Shopify's
// discount links do, or one they applied themselves. The order form applies it again whenever it is drawn anew.

/** Where the visit's code waits. */
const KEY = 'xshop:discount-code';

/** Where a shared link's code waits to be announced, until the shopper has seen the notice. */
const NOTICE_KEY = 'xshop:discount-code-notice';

/** What a code may look like in an address; anything else is ignored. */
const CODE = /^[A-Za-z0-9_-]{2,50}$/;

// Keeps a code for the visit; a browser that refuses storage simply forgets it.
export function keepDiscountCode(code: string): void {
  try { window.sessionStorage.setItem(KEY, code.toUpperCase()); } catch { /* storage refused: the code is typed again */ }
}

// Reads the visit's code, or null.
export function keptDiscountCode(): string | null {
  try { return window.sessionStorage.getItem(KEY); } catch { return null; }
}

// Forgets the visit's code, after the shopper removed it or the store refused it.
export function forgetDiscountCode(): void {
  try { window.sessionStorage.removeItem(KEY); } catch { /* nothing kept */ }
}

// Takes ?discount=CODE out of the address and keeps the code, so a reload or a copied address does not carry it on,
// and marks it to be announced.
export function takeSharedDiscount(): void {
  const url = new URL(window.location.href);
  const code = url.searchParams.get('discount');
  if (code === null) return;
  url.searchParams.delete('discount');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  if (!CODE.test(code)) return;
  keepDiscountCode(code);
  try { window.sessionStorage.setItem(NOTICE_KEY, code.toUpperCase()); } catch { /* no notice without storage */ }
}

// Reads the shared code still to be announced, or null.
export function pendingNotice(): string | null {
  try { return window.sessionStorage.getItem(NOTICE_KEY); } catch { return null; }
}

// Marks the shared code as announced.
export function noticeSeen(): void {
  try { window.sessionStorage.removeItem(NOTICE_KEY); } catch { /* nothing kept */ }
}
